import { differenceInDays } from "date-fns";
import format from "date-fns/format";
import { parseDate } from "./helpers";
import { t } from "./translator";
import abTesting from '../services/abTesting';
import { getDateFnsLocale } from './localeUtils';

export const getDateLabel = ({
  type,
  startDate,
  endDate,
  months,
  initial
}) => {
  const isFullDate = type === 'specific' && startDate && endDate;
  const getStartDate = !startDate
    ? t('mainFilter.any')
    : format(
        parseDate(startDate),
        isFullDate ? 'd MMM' : 'MMM',
        { locale: getDateFnsLocale() }
      );
  const getEndDate = !endDate
    ? t('mainFilter.any')
    : format(
        parseDate(endDate),
        isFullDate ? 'd MMM' : 'MMM',
        { locale: getDateFnsLocale() }
      );

  if (type === 'specific') {
    if (abTesting.showDaysOnCard) {
      const startDateText = startDate ? format(parseDate(startDate), 'E, d MMM') : t('mainFilter.any');
      const endDateText = startDate ? format(parseDate(endDate), 'E, d MMM') : t('mainFilter.any');
      return (<><span>{startDateText}</span> <span>{endDateText}</span></>)
    }

    return  (<span>{getStartDate}</span>)
  };
  if (type === 'range') return `${getStartDate} - ${getEndDate}`;
  if (type === 'month') {
    let label;
    if (months.length > 0) {
      label = months.map(m => format(parseDate(m, 'M'), 'MMM')).join(', ')
    } else {
      label = t('mainFilter.any_dates');
    }

    return <span>{label}</span>
  }
  if (!type) {
    const {
      specific: { start, end },
    } = initial;

    return (<><span>{format(parseDate(start), isFullDate ? 'dd MMM' : 'MMM')}</span> <span>{format(parseDate(end), isFullDate ? 'dd MMM' : 'MMM')}</span></>)
  }
};

export const getNightsLabel = (when) => {
  const { minNights, maxNights, initial } = when;
  const {
    flexible: { min, max },
  } = initial;

  let nights = `${min}-${max}`;

  if (when.type === 'specific' && when.startDate && when.endDate) {
    nights = differenceInDays(
      parseDate(when.endDate, "dd/MM/yyyy"),
      parseDate(when.startDate, "dd/MM/yyyy")
    );
  } else if (minNights && maxNights) {
    nights = minNights === maxNights ? minNights : `${minNights}-${maxNights}`;
  }

  return  `${nights} ${t('dealItem.nights_plural', { count: 2 })}`;
};
